// extracted by mini-css-extract-plugin
export default {"city":"City_city__rCVN3","activeCity":"City_activeCity__cbOoc","addressId":"City_addressId__YyOtF","activeAddress":"City_activeAddress__2uJPO","hours":"City_hours__QZYhy"};